import { jsx as _jsx } from "react/jsx-runtime";
import { BadImplementationException, resolveContent } from '@nu-art/ts-common';
import { ICONS } from '../../../icons/index.js';
import { openContent } from '@nu-art/thunderstorm-frontend/index';
export const IconWithTooltip = (props) => {
    const Icon = ICONS[props.iconKey];
    if (!Icon)
        throw new BadImplementationException(`no icon for key ${props.iconKey}`);
    const direction = props.tooltipDir ?? 'top';
    const offset = props.offset ?? 6;
    return _jsx(Icon.component, { className: props.className, onClick: props.onClick, ...openContent.tooltip[direction]('icon-with-tooltip', resolveContent(props.content), { offset }) });
};
//# sourceMappingURL=IconWithTooltip.js.map